export default "__VITE_ASSET__Bvca3BMK__"